import { render, staticRenderFns } from "./NotYetSentOrders.vue?vue&type=template&id=5035e8c8&"
import script from "./NotYetSentOrders.vue?vue&type=script&lang=ts&"
export * from "./NotYetSentOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports